import { Button } from '../../components/ui/button';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '../../components/ui/card';
import { Image, Copy, Download } from 'lucide-react';

export interface Banner {
  id: string;
  name: string;
  size: string;
  image: string;
  clicks: number;
}

interface BannerLibraryProps {
  banners: Banner[];
  onExport: () => void;
}

const BannerLibrary = ({ banners, onExport }: BannerLibraryProps) => {
  return (
    <Card>
      <CardHeader>
        <div className="flex items-start justify-between gap-4 w-full">
          <div>
            <CardTitle>Banner Library</CardTitle>
            <CardDescription>
              Download promotional banners for your campaigns
            </CardDescription>
          </div>
          <div className="flex items-center gap-2">
            <Button variant="outline" size="sm" onClick={onExport}>
              <Download className="h-4 w-4 mr-2" />
              Export
            </Button>
          </div>
        </div>
      </CardHeader>
      <CardContent>
        {banners.length === 0 ? (
          <p className="text-muted-foreground">No banners available</p>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {banners.map(banner => (
              <Card key={banner.id} className="overflow-hidden">
                <div className="aspect-video bg-muted flex items-center justify-center overflow-hidden">
                  {banner.image ? (
                    <img
                      src={banner.image}
                      alt={banner.name}
                      className="w-full h-full object-cover"
                    />
                  ) : (
                    <Image className="h-12 w-12 text-muted-foreground" />
                  )}
                </div>
                <CardContent className="p-4">
                  <div className="space-y-2">
                    <div className="font-medium">{banner.name}</div>
                    <div className="text-sm text-muted-foreground">
                      {banner.size}
                    </div>
                    <div className="text-sm text-muted-foreground">
                      Clicks: {banner.clicks}
                    </div>
                    <div className="flex gap-2 pt-2">
                      <Button variant="outline" size="sm" className="flex-1">
                        <Copy className="h-4 w-4 mr-2" />
                        Copy HTML
                      </Button>
                      <Button variant="outline" size="sm" className="flex-1">
                        <Download className="h-4 w-4 mr-2" />
                        Download
                      </Button>
                    </div>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default BannerLibrary;
